// @vendors
const Immutable = require('immutable');
const get = require('lodash/object/get');
const first = require('lodash/array/first');
const flattenDeep = require('lodash/array/flattenDeep');
const trim = require('lodash/string/trim');
const actionTypes = require('constants/actionTypes');
const moment = require('moment')

// @reducers
const brokerConvenienceMiFIDTestStep0Reducer = require('./brokerConvenienceMiFIDTest/brokerConvenienceMiFIDTestStep0');
const brokerConvenienceMiFIDTestStep1Reducer = require('./brokerConvenienceMiFIDTest/brokerConvenienceMiFIDTestStep1');
const brokerConvenienceMiFIDTestStep2Reducer = require('./brokerConvenienceMiFIDTest/brokerConvenienceMiFIDTestStep2');
const brokerConvenienceMiFIDTestStep3Reducer = require('./brokerConvenienceMiFIDTest/brokerConvenienceMiFIDTestStep3');
const brokerConvenienceMiFIDTestStep4Reducer = require('./brokerConvenienceMiFIDTest/brokerConvenienceMiFIDTestStep4');
const brokerConvenienceMiFIDTestStepSuccessReducer = require('./brokerConvenienceMiFIDTest/brokerConvenienceMiFIDTestStepSuccess');
const brokerConvenienceMiFIDTestStepOmitTestReducer = require('./brokerConvenienceMiFIDTest/brokerConvenienceMiFIDTestStepOmitTest');
const brokerConvenienceMiFIDv2Reducer = require('./brokerConvenienceMiFIDTest/brokerConvenienceMiFIDv2');

// @ utils
const UrlHelper = require('utilities/urlHelper');
const { isRenderStep0 } = require('mifid/utilities/mifidValidHelper')
const {
    buildCategoryName,
    buildCategoryIcon,
    buildSubCategoryName,
    buildSubCategoryTitle,
    buildSubCategoryDescription,
    buildSectionName,
    buildQuestionIcon,
    buildQuestionInformation,
    buildTag,
    buildAnswersWithTag,
    buildQuestionDisclaimer,
    buildQuestionSecondDisclaimer,
    buildQuestionLabel,
    buildQuestionFootstep,
    buildInvalidAnswerText,
    buildSummaryLabel,
    buildComponentTag,
} = require('mifid/utilities/mifidTestTextHelper');
const { isPrivateEquityTest, isPrivateEquityTestExpired } = require('mifid/utilities/mifidPrivateEquityHelper');

// @constants
const {
    MIFID_STEP_ZERO,
    FIRST_STEP,
    SECOND_STEP,
    THIRD_STEP,
    FOURTH_STEP,
    FIFTH_STEP,
    WIZARD_FIRST_STEP,
    WIZARD_SECOND_STEP,
    WIZARD_THIRD_STEP,
    WIZARD_FOURTH_STEP,
    BROKER_MIFID_ACTION_MANUAL_TEST,
    MYPROFILE_BROKER_CONVENIENCE_MIFID_TEST_WIZARD_URL,
    MYPROFILE_BROKER_URL,
    BROKER_MIFID_2_DISCLAIMER_ACTION,
    BROKER_MIFID_VERSION_1,
    BROKER_MIFID_VERSION_2
} = require('constants/index');

const { QUESTION_TYPE_TEXT, QUESTION_TYPE_MODAL } = require('mifid/constants/constants');

const {
    BROKER_CONVENIENCE_MIFID_TEST_RESULT_DISPLAYED,
    BROKER_CONVENIENCE_MIFID_TEST_CONSULT,
    BROKER_CONVENIENCE_MIFID_TEST_HARD_RESET,
    BROKER_CONVENIENCE_MIFID_TEST_RESET,
    BROKER_CONVENIENCE_MIFID_TEST_START,
    BROKER_CONVENIENCE_MIFID_TEST_SET_OPERATION_CODE_US_PERSON,
    BROKER_CONVENIENCE_MIFID_TEST_FETCH_GET_TEST_SUCCESS,
    BROKER_CONVENIENCE_MIFID_TEST_FINISH_LOADING,
    BROKER_CONVENIENCE_MIFID_TEST_FINISH_ERROR,
    BROKER_CONVENIENCE_MIFID_TEST_FINISH,
    BROKER_CONVENIENCE_MIFID_TEST_OMIT,
    BROKER_CONVENIENCE_MIFID_TEST_SET_VISIBLE_STEP,
    BROKER_CONVENIENCE_MIFID_TEST_STEP3_VERIFY_ANSWERS,
    BROKER_CONVENIENCE_MIFID_TEST_VALIDATE_STEP,
    BROKER_CONVENIENCE_MIFID_TEST_STEP1_CHANGE_STUDY_LEVEL,
    BROKER_CONVENIENCE_MIFID_TEST_STEP1_CHANGE_EXPERIENCE,
    BROKER_CONVENIENCE_MIFID_TEST_STEP2_CHANGE_FINANCIAL_CULTURE,
    BROKER_CONVENIENCE_MIFID_TEST_STEP3_CLOSE_INVALID_ANSWERS_MODAL,
    BROKER_CONVENIENCE_MIFID_TEST_STEP3_CHANGE_EXPERIENCE_AS_INVESTOR,
    BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_GO_TO_MY_WALLET,
    BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_CONTINUE_OPERATION,
    BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_CONTINUE_OPERATION_VALIDATE,
    BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_CHANGE_ACCEPT_EVALUATION,
    BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_OPERATE_OMITTING_TEST,
    BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_NOT_CONVENIENT_ACCEPT,
    BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_GO_TO_MAKE_TEST,
    BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_CHANGE_TRANSCRIPTION,
    BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_CANCEL,
    BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_CONTINUE,
    BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_CONTINUE_SUCCESS,
    BROKER_CONVENIENCE_MIFID_TEST_RETAKE_TEST,
    BROKER_CONVENIENCE_MIFID_TEST_STEPS_INITIAL_STEPS,
    BROKER_GET_MY_INVESTMENTS_SUCCESS,
} = require('constants/actionTypes');

const {
    BROKER_CONVENIENCE_MIFID_TEST_FETCH_GET_TEST_FETCHING,
    BROKER_CONVENIENCE_MIFID_TEST_STEP0_CHANGE_UPDATE_REASON,
    BROKER_CONVENIENCE_MIFID_TEST_STEP1_CHECK_INCOHERENCES,
    BROKER_CONVENIENCE_MIFID_TEST_STEP1_CONTINUE_WITH_INCOHERENCES,
    BROKER_CONVENIENCE_MIFID_TEST_STEP2_CHECK_INCOHERENCES,
    BROKER_CONVENIENCE_MIFID_TEST_STEP2_CONTINUE_WITH_INCOHERENCES,
    BROKER_CONVENIENCE_MIFID_TEST_STEP3_CHECK_INCOHERENCES,
    BROKER_CONVENIENCE_MIFID_TEST_STEP3_CONTINUE_WITH_INCOHERENCES,
    BROKER_CONVENIENCE_MIFID_TEST_FETCH_CURRENT_TEST_RESULT_FETCHING,
    BROKER_CONVENIENCE_MIFID_TEST_FETCH_CURRENT_TEST_RESULT_SUCCESS_APPROVED,
    BROKER_CONVENIENCE_MIFID_TEST_FETCH_CURRENT_TEST_RESULT_SUCCESS_DISAPPROVED,
    BROKER_CONVENIENCE_MIFID_TEST_FETCH_CURRENT_TEST_RESULT_ERROR,
    BROKER_CONVENIENCE_MIFID_TEST_CONTINUE_WITH_DISAPPROVED_TEST,
    BROKER_CONVENIENCE_MIFID_TEST_REVIEW_DISAPPROVED_TEST,
    BROKER_CONVENIENCE_MIFID_TEST_RESET_TEST_SCORE_STATUS,
    BROKER_CONVENIENCE_MIFID_TEST_UPDATE_CATEGORY_AND_SUBCATEGORY,
    BROKER_CONVENIENCE_MIFID_TEST_UPDATE_ANSWER,
    BROKER_CONVENIENCE_MIFID_TEST_GO_TO_CONFIRMATION_STEP,
    BROKER_CONVENIENCE_MIFID_TEST_GO_TO_FINISH_STEP,
    BROKER_CONVENIENCE_MIFID_TEST_GO_TO_STEP,
    BROKER_CONVENIENCE_MIFID_TEST_REVIEWING_TEST,
    BROKER_CONVENIENCE_MIFID_TEST_DISABLED_BUTTON,
    BROKER_CONVENIENCE_MIFID_TEST_ENABLE_BUTTON,
    BROKER_CONVENIENCE_MIFID_TEST_SHOW_MODAL,
    BROKER_CONVENIENCE_MIFID_TEST_IS_ACCORDION_ANSWER,
    BROKER_CONVENIENCE_MIFID_TEST_UPDATE_LIST_ANSWER_WITH_COHERENCE,
    BROKER_CONVENIENCE_MIFID_TEST_SHOW_PROFESSIONAL_EXPERIENCE_MODAL,
    BROKER_CONVENIENCE_MIFID_TEST_SHOW_DIFFERENCE_MODAL,
    BROKER_CONVENIENCE_MIFID_TEST_HIDE_DIFFERENCE_MODAL,
    BROKER_CONVENIENCE_MIFID_TEST_SHOW_PROFESSIONAL_EXPERIENCE_MODAL_WARNING,
    BROKER_CONVENIENCE_MIFID_TEST_HIDE_FIRST_TIME_POP_UP,
    BROKER_CONVENIENCE_MIFID_TEST_GET_INVESTMENT_EXPERIENCE_SUCCESS,
    BROKER_CONVENIENCE_MIFID_TEST_HANDLE_CLOSE_MODAL_INVESTMENT_EXPERIENCE,
    BROKER_CONVENIENCE_MIFID_TEST_ADD_PRIVATE_EQUITY_DISCLAIMERS,
    BROKER_CONVENIENCE_MIFID_TEST_SET_CRYPTO_TEST_STATE,
    BROKER_CONVENIENCE_MIFID_TEST_SET_CRYPTO_TEST_INDEX,
    BROKER_CONVENIENCE_MIFID_TEST_SET_CRYPTO_TEST_LENGTH,
    BROKER_CONVENIENCE_MIFID_TEST_VERIFY_DOCUMENT_SIGNED_LOADING,
    BROKER_CONVENIENCE_MIFID_TEST_VERIFY_DOCUMENT_SIGNED_SUCCESS,
    BROKER_CONVENIENCE_MIFID_TEST_VERIFY_DOCUMENT_SIGNED_ERROR,
    BROKER_CONVENIENCE_MIFID_TEST_SET_EDITION_MODE,
    BROKER_CONVENIENCE_MIFID_TEST_CLOSE_CRYPTO_RESULT_MODAL,
    BROKER_CONVENIENCE_MIFID_TEST_GET_CRYPTO_DOCUMENTATION_LOADING,
    BROKER_CONVENIENCE_MIFID_TEST_GET_CRYPTO_DOCUMENTATION_SUCCESS,
    BROKER_CONVENIENCE_MIFID_TEST_GET_CRYPTO_DOCUMENTATION_ERROR,
    BROKER_CONVENIENCE_MIFID_TEST_REQUEST_CRYPTO_DOCUMENTATION_LOADING,
    BROKER_CONVENIENCE_MIFID_TEST_REQUEST_CRYPTO_DOCUMENTATION_SUCCESS,
    BROKER_CONVENIENCE_MIFID_TEST_REQUEST_CRYPTO_DOCUMENTATION_ERROR,
    BROKER_CONVENIENCE_MIFID_TEST_SIGN_DOCUMENT_LOADING,
    BROKER_CONVENIENCE_MIFID_TEST_SIGN_DOCUMENT_SUCCESS,
    BROKER_CONVENIENCE_MIFID_TEST_SIGN_DOCUMENT_ERROR,
} = require('mifid/constants/actionTypes');

import {
    REASON_EXPIRED_TEST,
    CRYPTO_TEST_ID,
    STUDY_LEVEL_ANSWER_MAP_FROM_COMMON_TO_CRYPTO,
    EXPERIENCE_ANSWER_MAP_FROM_COMMON_TO_CRYPTO
} from 'mifid/constants/constants'

const INITIAL_STATE = Immutable.fromJS({
    mifidVersion: BROKER_MIFID_VERSION_1,
    browseHistory: [],
    consulting: false,
    productName: '',
    productUrl: '',
    productId: null,
    urlContinueOperation: null,
    isCancelPathAbsolute: false,
    cancelPath: null,
    // If the operation can't continue using a simple url to continue, we will use these
    operationType: null,
    operationData: null,
    steps: [
        brokerConvenienceMiFIDTestStep1Reducer(undefined, {}),
        brokerConvenienceMiFIDTestStep2Reducer(undefined, {}),
        brokerConvenienceMiFIDTestStep3Reducer(undefined, {}),
        brokerConvenienceMiFIDTestStep4Reducer(undefined, {})
    ],
    started: false,
    resultDisplayed: false,
    isEvaluationAccepted: false,
    isEvaluationAcceptedInvalid: false,
    continueOperationAcceptingResponsability: false,
    operateOmittingTest: false,
    omitTestTrascriptionText: '',
    omitTestInvalidText: false,
    omitTestCanContinue: false,
    visibleStep: WIZARD_FIRST_STEP,
    action: undefined,
    resultText: '',
    disclaimer: '',
    finished: false,
    isReviewingTest: false,
    loading: false,
    retakeTest: false,
    requiresTest: false,
    fetched: false,
    fetching: false,
    mifidv2: brokerConvenienceMiFIDv2Reducer(undefined, {}),
    loadingCurrentTest: false,
    fetchedCurrentTest: false,
    errorCurrentTest: false,
    disaprovedCurrentTest: false,
    continueWithDisapproved: false,
    hasRoboPortfolio: false,
    myInvestmentError:false,
    test:{
        schema:{
            categories: [],
        },
        testState: {
            currentStepCategory: 0,
            currentStepSubCategory: 0
        },
        allTests:[],
        testToEvaluate: {},
        confirmationStatus: '',
        testStatus: 'inProgress',
        attempts: 0,
        isFirsTest: true,
        isV3Test: false,
        isCryptoTest: false,
        cryptoTestIndex: 0,
        cryptoTestState: '',
        cryptoTestLength: 0,
        cryptoModalResult: false,
        cryptoDocumentation: {
            cryptoDocumentationLoading: false,
            base64String: null,
            base64url: null,
            cryptoOperationProcessId: null,
            cryptoOperationProcessIdLoading: false,
            cryptoDocumentationSignLoading: false,
            cryptoDocumentationSigned: false,
        },
        documentationHasSigned: false,
        verifyDocumentationLoading: false,
        takeTestWithAllQuestions: false,
        isEditing: false,
    },
    disabledButton: true,
    isAccordionAnswer: false,
    listAnswerWithCoherence: [],
    showCoherenceModal: false,
    showProfessionalExperienceModal: false,
    showDifferenceModal: false,
    showProfessionalExperienceModalWarning: false,
    showFirsTimePopUp: false,
    investmentExperience: null,
    showInvestmentExperienceModal: false,
});

const getInitialState = (immState) => INITIAL_STATE.set('browseHistory', immState.get('browseHistory'));

/**
 * @param {numeric} whichStep Step starting from zero
 * @returns {any} Step reducer
 * @throws {Error} If no reducer is found for step whichStep
 */
function getReducerByStep(whichStep) {
    if(isRenderStep0()){
        switch (whichStep) {
            case FIRST_STEP:
                return brokerConvenienceMiFIDTestStep0Reducer;
            case SECOND_STEP:
                return brokerConvenienceMiFIDTestStep1Reducer;
            case THIRD_STEP:
                return brokerConvenienceMiFIDTestStep2Reducer;
            case FOURTH_STEP:
                return brokerConvenienceMiFIDTestStep3Reducer;
            case FIFTH_STEP:
                return brokerConvenienceMiFIDTestStep4Reducer;
            default:
                throw new Error(`No reducer for step ${whichStep}`);
        }
    }else{
        switch (whichStep) {
            case FIRST_STEP:
                return brokerConvenienceMiFIDTestStep1Reducer;
            case SECOND_STEP:
                return brokerConvenienceMiFIDTestStep2Reducer;
            case THIRD_STEP:
                return brokerConvenienceMiFIDTestStep3Reducer;
            case FOURTH_STEP:
                return brokerConvenienceMiFIDTestStep4Reducer;
            default:
                throw new Error(`No reducer for step ${whichStep}`);
        }
    }
}

/**
 * @param {Immutable.Map} immState
 * @param {numeric} stepNumber Step to update (starting from zero)
 * @param {Object} action
 * @returns {Immutable.List}
 */
function updateStep(immState, stepNumber, action) {
    const step = isRenderStep0() ? stepNumber+1 : stepNumber;
    const reducer = getReducerByStep(step);
    const immSteps = immState.get('steps');
    const immStep = immSteps.get(step);
    const immUpdatedSteps = immSteps.set(step, reducer(immStep, action));

    return immUpdatedSteps;
}

/**
 * @param {Immutable.Map} immState
 * @param {numeric} previousStep Starting from 1
 * @returns {Immutable.Map}
 */
function goToPreviousStep(immState, previousStep) {
    return immState
        .mergeIn(['steps', FIRST_STEP], { valid: previousStep > WIZARD_FIRST_STEP, validated: previousStep > WIZARD_FIRST_STEP })
        .mergeIn(['steps', SECOND_STEP], { valid: previousStep > WIZARD_SECOND_STEP, validated: previousStep > WIZARD_SECOND_STEP })
        .mergeIn(['steps', THIRD_STEP], { valid: previousStep > WIZARD_THIRD_STEP, validated: previousStep > WIZARD_THIRD_STEP })
        .mergeIn(['steps', FOURTH_STEP], { valid: previousStep > WIZARD_FOURTH_STEP, validated: previousStep > WIZARD_FOURTH_STEP })
        .set('visibleStep', previousStep);
}

/**
 * @param {Immutable.Map} immState
 * @param {numeric} newVisibleStep Starting from 1
 * @returns {Immutable.Map}
 */
function updateVisibleStep(immState, newVisibleStep) {
    const goPrevious = immState.get('visibleStep') > newVisibleStep;

    if (goPrevious) {
        return goToPreviousStep(immState, newVisibleStep);
    } else {
        return immState.set('visibleStep', newVisibleStep);
    }
}

function finish(immState, response) {
    const repeatSentence = trim(get(response, "frase.disclaimer") || get(response, "frase"));
    const repeatSentenceClean = trim(first(/".*?"/.exec(repeatSentence))).replace(/"/g, "");
    const disclaimer = trim(get(response, "disclaimer.disclaimer") || get(response, "disclaimer"));
    const isRejecting = get(response, "result") === "R";
    const newState = immState.merge({
        loading: false,
        finished: isRejecting,
        action: get(response, "accion") || BROKER_MIFID_ACTION_MANUAL_TEST,
        resultText: trim(get(response, "puntuacion.descripcion")),
        disclaimer,
        repeatSentence,
        repeatSentenceClean,
    }).setIn(["test", "cryptoModalResult"], true);
    return newState.setIn(["test", "confirmationStatus"], "success");
}

/**
 * @param {Immutable.Map} immState
 * @param {String} productId
 * @param {String|string[]|null} urlContinueOperation
 * @param {String|null} operationType
 * @param {Object|null} operationData Object holding data to continue operation after finishing mifid test
 * @param {String|undefined} cancelPath Where to redirect if the user clicks on cancel in the test
 * @returns {Immutable.Map}
 */
function start(immState, {
    productName,
    productUrl,
    productId,
    urlContinueOperation,
    operationType,
    operationData,
    cancelPath,
    mifidVersion = BROKER_MIFID_VERSION_1
}) {
    const immBrowseHistory = immState.get('browseHistory');
    const invalidCancelPaths = immBrowseHistory.takeLast(1).push(MYPROFILE_BROKER_CONVENIENCE_MIFID_TEST_WIZARD_URL);
    const isNotManualTest = !get(operationData, 'isManualTest');
    const hasRoboPortfolio = immState.get('hasRoboPortfolio');
    const showFirsTimePopUp= immState.get('showFirsTimePopUp');
    const finalCancelPath = cancelPath
        ? cancelPath
        : !invalidCancelPaths.contains(immBrowseHistory.first())
            ? immBrowseHistory.first()
            : MYPROFILE_BROKER_URL;

    const isCancelPathAbsolute = UrlHelper.isAbsolute(cancelPath);
    return getInitialState(immState).merge({
        started: true,
        displayOmitTestButton: isNotManualTest,
        productName,
        productUrl,
        productId,
        urlContinueOperation: urlContinueOperation ? flattenDeep([urlContinueOperation]) : urlContinueOperation,
        operationType,
        operationData,
        hasRoboPortfolio,
        cancelPath: finalCancelPath,
        isCancelPathAbsolute: isCancelPathAbsolute,
        mifidVersion,
        showFirsTimePopUp,
        showInvestmentExperienceModal: immState.get('showInvestmentExperienceModal'),
        test: immState.get('test'),
    });
}

/**
 * @param {Immutable.Map} immState
 * @returns {Immutable.Map}
 */
function reset(immState) {
    const productName = immState.get('productName');
    const productUrl = immState.get('productUrl');
    const productId = immState.get('productId');
    const urlContinueOperation = immState.get('urlContinueOperation');
    const operationType = immState.get('operationType');
    const operationData = immState.get('operationData');
    const cancelPath = immState.get('cancelPath');
    const mifidVersion = immState.get('mifidVersion');

    return start(immState, {
        productName,
        productUrl,
        productId,
        urlContinueOperation,
        operationType,
        operationData,
        cancelPath,
        mifidVersion
    });
}

const updateAnswer = (immTest, data) => {
    const { sectionId, questionId, newValue, error } = data;
    const schema = immTest.get("schema").toJS();
    const immQuestion = immTest.getIn(['testToEvaluate', 'test','question']).find((q) => q.get('id') === questionId)
    const currentStepCategory = immQuestion.get('category');
    const currentStepSubCategory = immQuestion.get('subcategory');
    return {
        categories: schema.categories.map((category) => {
            if (category.id === currentStepCategory) {
                return {
                    ...category,
                    subCategories: category.subCategories.map((subCategory) => {
                        if (subCategory.id === currentStepSubCategory) {
                            return {
                                ...subCategory,
                                sections: subCategory.sections.map((section) => {
                                    if (section.id === sectionId) {
                                        return {
                                            ...section,
                                            questions: section.questions.map((question) => {
                                                if (question.id === questionId) {
                                                    if (question.inputType === QUESTION_TYPE_TEXT) {
                                                        return {
                                                            ...question,
                                                            invalidAnswer: error,
                                                            answer: question.answer.map((ans) => {
                                                                return {
                                                                    ...ans,
                                                                    description: newValue,
                                                                    selected: newValue,
                                                                };
                                                            }),
                                                        };
                                                    } else {
                                                        if (question.inputType === QUESTION_TYPE_MODAL &&
                                                            newValue === 'closeModal') {
                                                            return {
                                                                ...question,
                                                                isOpen: false,
                                                                invalidAnswer: error,
                                                            }
                                                        }
                                                        return {
                                                            ...question,
                                                            invalidAnswer: error,
                                                            answer: question.answer.map((ans) => {
                                                                return {
                                                                    ...ans,
                                                                    selected: ans.id === newValue
                                                                        ? "S"
                                                                        : "N",
                                                                };
                                                            }),
                                                        };
                                                    }
                                                }
                                                return question;
                                            }),
                                        };
                                    }
                                    return section;
                                }),
                            };
                        }
                        return subCategory;
                    }),
                };
            }
            return category;
        }),
    };
};

const setModalQuestionOpenState = (testToEvaluateId, question, reason, lastDateTest) => {
    const isAlternativeFundsTest = isPrivateEquityTest(testToEvaluateId);
    const isModalQuestion = question.inputType === QUESTION_TYPE_MODAL;
    if (isAlternativeFundsTest && question.id === '1' &&  reason === '1') {
        const executionDateAfter6Months = moment(lastDateTest, "DD/MM/YYY HH:mm:ss").add(6, 'month');
        const today = moment();
        if (executionDateAfter6Months.isBefore(today)) {
            return false;
        } else {
            return isModalQuestion
        }
    }

    return isModalQuestion
}

const buildSchema = (test, testToEvaluateId, reason, lastDateTest, isV3Test) => {
    const isAlternativeFundsTest = isPrivateEquityTest(testToEvaluateId);
    const questions = test.question;
    let schema = {
        categories: [],
    };
    questions.forEach((question) => {

        const previousCategoryCount = questions.filter(
            (e) => e.category === question.category - 1
        );

        const hasQuestion200 = questions.find(
            (question) => question.id === "200"
        );
        const step = hasQuestion200
            ? question.subcategory + previousCategoryCount.length
            : question.subcategory + previousCategoryCount.length + 1;


        if (question.id === "200") {
            const listAnswer = [];
            question.answer.map(item => {
                if(item.id !== '203') {
                    listAnswer.push(item)
                }
            })
            question.answer = listAnswer;
        } else if(question.id === "300") {
            const listAnswer = [];
            question.answer.map(item => {
                if(item.id !== '303') {
                    listAnswer.push(item)
                }
            })
            question.answer = listAnswer;
        }
        const questionCategory = question.category;
        const questionSubCategory = question.subcategory;
        const questionSection = question.section;

        let category = schema.categories.find(
            (categoryItem) => categoryItem.id === questionCategory
        );

        const categoryName = buildCategoryName(questionCategory, isAlternativeFundsTest)

        if (!category) {
            const newCategory = {
                id: questionCategory,
                name: categoryName,
                icon: buildCategoryIcon(questionCategory, isAlternativeFundsTest),
                categoryTag: buildTag(categoryName, isAlternativeFundsTest),
                subCategories: [],
            };
            schema.categories.push(newCategory);
            category = schema.categories.find(
                (categoryItem) => categoryItem.id === questionCategory
            );
        }

        let subCategory = category.subCategories.find(
            (subCategoryItem) => subCategoryItem.id === questionSubCategory
        );

        const subCategoryName = buildSubCategoryName(
            questionCategory,
            questionSubCategory,
            isAlternativeFundsTest,
            isV3Test,
        );

        if (!subCategory) {
            const newSubCategory = {
                id: questionSubCategory,
                name: subCategoryName,
                subcategoryTag: buildTag(subCategoryName),
                subCategoryTitle: buildSubCategoryTitle(
                    questionCategory,
                    questionSubCategory,
                    isAlternativeFundsTest,
                    isV3Test,
                ),
                subCategoryDescription: buildSubCategoryDescription(
                    questionCategory,
                    questionSubCategory,
                    isAlternativeFundsTest,
                    isV3Test,
                ),
                sections: [],
                step,
            };
            category.subCategories.push(newSubCategory);
            subCategory = category.subCategories.find(
                (subCategoryItem) => subCategoryItem.id === questionSubCategory
            );
        }

        let section = subCategory.sections.find(
            (sectionItem) => sectionItem.id === questionSection
        );
        if (!section) {
            const newSection = {
                id: questionSection,
                name: buildSectionName(
                    questionSection,
                    questionCategory,
                    questionSubCategory,
                    isAlternativeFundsTest,
                    isV3Test,
                ),
                questions: [],
            };
            subCategory.sections.push(newSection);
            section = subCategory.sections.find(
                (sectionItem) => sectionItem.id === questionSection
            );
        }

        const newQuestion = {
            ...question,
            icon: buildQuestionIcon(
                question.id,
                questionSection,
                questionCategory,
                questionSubCategory,
                isAlternativeFundsTest,
                isV3Test,
            ),
            information: buildQuestionInformation(
                question.id,
                questionSection,
                questionCategory,
                questionSubCategory,
                isAlternativeFundsTest,
                isV3Test,
            ),
            disclaimer: buildQuestionDisclaimer(
                question.id,
                questionSection,
                questionCategory,
                questionSubCategory,
                isAlternativeFundsTest,
                isV3Test,
            ),
            secondDisclaimer: buildQuestionSecondDisclaimer(
                question.id,
                questionSection,
                questionCategory,
                questionSubCategory,
                isAlternativeFundsTest
            ),
            label: buildQuestionLabel(
                question.id,
                questionSection,
                questionCategory,
                questionSubCategory,
                isAlternativeFundsTest
            ),
            summaryLabel: buildSummaryLabel(
                question.id,
                questionSection,
                questionCategory,
                questionSubCategory,
            ),
            footstep: buildQuestionFootstep(
                question.id,
                questionSection,
                questionCategory,
                questionSubCategory,
                isAlternativeFundsTest
            ),
            isOpen: setModalQuestionOpenState(testToEvaluateId, question, reason, lastDateTest),
            invalidAnswer: false,
            invalidAnswerText: buildInvalidAnswerText(
                question.id,
                questionSection,
                questionCategory,
                questionSubCategory,
                isAlternativeFundsTest
            ),
            questionTag: buildTag(question.description),
            componentTag: buildComponentTag(question.id),
            answer: buildAnswersWithTag(question.answer, question.inputType)
        };
        section.questions.push(newQuestion);
    });
    return schema;
}

const buildTest = (response) => {
    const allTests = get(response, 'getTestListado');
    const testToEvaluateId = get(response, 'tipoTestEvaluado');
    const isCryptoTest = testToEvaluateId === CRYPTO_TEST_ID;
    let testToEvaluate = allTests.find(test => testToEvaluateId === test.tipoTest);
    const reason = get(testToEvaluate, 'razon');
    const isExpired = reason === REASON_EXPIRED_TEST;
    if (
        testToEvaluate.test &&
        testToEvaluate.test.question &&
        (
            (isPrivateEquityTest(testToEvaluateId) &&
            testToEvaluate.lastDateTest &&
            isPrivateEquityTestExpired(testToEvaluate.lastDateTest)) ||
            isCryptoTest
        )
    ) {
        testToEvaluate = {
            ...testToEvaluate,
            test: {
                ...testToEvaluate.test,
                question: testToEvaluate.test.question.filter(
                    (question) => question.id !== "1"
                ),
            },
        };
    }

    if (isCryptoTest) {
        testToEvaluate = {
            ...testToEvaluate,
            test: {
            ...testToEvaluate.test,
            question: testToEvaluate.test.question.map(question => ({
                ...question,
                answer: question.id === '4' || question.id === '9' 
                ? question.answer
                : question.answer.map(answer => ({
                    ...answer,
                    selected: ""
                }))
            }))
            }
        };

        let studyLevelQuestionAlreadyAnswered = false;
        let experienceQuestionAlreadyAnswered = false;
        const studyLevelCryptoQuestion = testToEvaluate.test.question.find(q => q.id === '4');
        const experienceCryptoQuestion = testToEvaluate.test.question.find(q => q.id === '9');

        if (studyLevelCryptoQuestion) {
            studyLevelQuestionAlreadyAnswered = studyLevelCryptoQuestion.answer.some(a => a.selected === 'S');
        }

        if (experienceCryptoQuestion) {
            experienceQuestionAlreadyAnswered = experienceCryptoQuestion.answer.some(a => a.selected === 'S');
        }

        const preguntasComunes = get(response, 'testPreguntasComunes.question', []);
        const studyLevel = preguntasComunes.find(q => q.id === '308');
        const experienceAsInvestor = preguntasComunes.find(q => q.id === '304');

        if (studyLevel && !studyLevelQuestionAlreadyAnswered) {
            const selectedStudyLevelId = studyLevel.answer.find(a => a.selected === 'S')?.id;

            if (selectedStudyLevelId && STUDY_LEVEL_ANSWER_MAP_FROM_COMMON_TO_CRYPTO[selectedStudyLevelId]) {
                testToEvaluate = {
                    ...testToEvaluate,
                    test: {
                        ...testToEvaluate.test,
                        question: testToEvaluate.test.question.map(q => {
                            if (q.id === '4') {
                                return {
                                    ...q,
                                    answer: q.answer.map(a => ({
                                        ...a,
                                        selected: a.id === STUDY_LEVEL_ANSWER_MAP_FROM_COMMON_TO_CRYPTO[selectedStudyLevelId] ? 'S' : 'N'
                                    }))
                                };
                            }
                            return q;
                        })
                    }
                };
            }
        }

        if (experienceAsInvestor && !experienceQuestionAlreadyAnswered) {
            const selectedExperienceId = experienceAsInvestor.answer.find(a => a.selected === 'S')?.id;

            if (selectedExperienceId && EXPERIENCE_ANSWER_MAP_FROM_COMMON_TO_CRYPTO[selectedExperienceId]) {
                testToEvaluate = {
                    ...testToEvaluate,
                    test: {
                        ...testToEvaluate.test,
                        question: testToEvaluate.test.question.map(q => {
                            if (q.id === '9') {
                                return {
                                    ...q,
                                    answer: q.answer.map(a => ({
                                        ...a,
                                        selected: a.id === EXPERIENCE_ANSWER_MAP_FROM_COMMON_TO_CRYPTO[selectedExperienceId] ? 'S' : 'N'
                                    }))
                                };
                            }
                            return q;
                        })
                    }
                };
            }
        }
    }

    const isV3Test = testToEvaluate.test.question.some((q) => q.id === '304')
    const schema = buildSchema(
        testToEvaluate.test,
        testToEvaluateId,
        testToEvaluate.reason,
        testToEvaluate.lastDateTest,
        isV3Test
    );
    const attempts = get(response, 'intentos');
    const isFirsTest = testToEvaluate.test.question.every((q) => q.answer.every((ans)=> ans.selected === ''));
    return {
        allTests,
        testToEvaluate,
        schema,
        testState: {
            currentStepCategory: 0,
            currentStepSubCategory: 0
        },
        confirmationStatus: '',
        testStatus: 'inProgress',
        attempts: attempts && attempts[0] || 1,
        isFirsTest: isFirsTest,
        isV3Test,
        isCryptoTest,
    };
}

const locationChanged = (immState, pathname) => {
    const resultDisplayed = immState.get('resultDisplayed');

    if (resultDisplayed) {
        const urlContinueOperation = immState.get('urlContinueOperation');
        const newPathNotInContinuationUrls = (
            !urlContinueOperation ||
            !urlContinueOperation.includes(pathname)
        );

        // (franco.montenegro) Preserve some state so if the user finishes the test,
        // continues with the operation and then goes back, the mifid flow can run correctly again
        if (pathname === MYPROFILE_BROKER_CONVENIENCE_MIFID_TEST_WIZARD_URL) {
            return getInitialState(immState).merge({
                consulting: immState.get('consulting'),
                productName: immState.get('productName'),
                productUrl: immState.get('productUrl'),
                productId: immState.get('productId'),
                operationType: immState.get('operationType'),
                operationData: immState.get('operationData'),
                urlContinueOperation: immState.get('urlContinueOperation'),
                cancelPath: immState.get('cancelPath'),
                isCancelPathAbsolute: immState.get('isCancelPathAbsolute')
            });
        } else if (newPathNotInContinuationUrls) {
            return getInitialState(immState);
        }
    }

    return immState;
};

const preserveBrowseHistory = (immState, newPath) => {
    if (MYPROFILE_BROKER_CONVENIENCE_MIFID_TEST_WIZARD_URL === newPath) {
        return immState;
    }

    return immState
        .updateIn(['browseHistory'], browseHistory => browseHistory.push(newPath))
        .updateIn(['browseHistory'], browseHistory => browseHistory.takeLast(2));
};

const findPhraseToTranscribe = (immMifidv2) => {
    const phraseWithPhrase = immMifidv2.get('disclaimers').find((immDisclaimer) => {
        return (
            immDisclaimer.get("id") === "D4A" ||
            immDisclaimer.get("id") === "D2A" ||
            immDisclaimer.get("id") === "EC4" ||
            immDisclaimer.get("id") === "EC3" ||
            immDisclaimer.get("id") === "EC2" ||
            immDisclaimer.get("id") === "EC1"
        );
    })
    return phraseWithPhrase ? phraseWithPhrase.get('phrase') : false;
}

const findPhrseDescription = (immMifidv2) => {
    const phraseWithPhrase = immMifidv2.get('disclaimers').find((immDisclaimer) => {
        return (
            immDisclaimer.get("id") === "D4A" ||
            immDisclaimer.get("id") === "D2A" ||
            immDisclaimer.get("id") === "EC4" ||
            immDisclaimer.get("id") === "EC3" ||
            immDisclaimer.get("id") === "EC2" ||
            immDisclaimer.get("id") === "EC1"

        );
    })
    return phraseWithPhrase ? phraseWithPhrase.get('description') : false;
}

const applyMifid2Layer = (immState, immMifidv2) => {
    const isUsingMifidv2 = immState.get('mifidVersion') === BROKER_MIFID_VERSION_2;
    const isManual = immState.getIn(['operationData', 'isManualTest']);
    const phrase = findPhraseToTranscribe(immMifidv2);
    const description = findPhrseDescription(immMifidv2)

    if (isUsingMifidv2) {
        return immState.merge({
            mifidv2: immMifidv2,
            requiresTest: immMifidv2.get('requiresTest'),
            repeatSentence: phrase,
            repeatSentenceClean: phrase,
            descriptionRepeatSentence: description,
            resultText: immMifidv2.get('resultText'),
            action: isManual ? BROKER_MIFID_ACTION_MANUAL_TEST : BROKER_MIFID_2_DISCLAIMER_ACTION,
        });
    }

    return immState;
};

const showPopup =(response) => {
    return response.mostrarAviso === 'S';
}

/**
 * @param {Immutable.Map} state
 * @param {Object} action
 * @returns {Immutable.Map}
 */
function brokerConvenienceMiFIDTestReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case actionTypes.LOCATION_CHANGE:
            const pathname = action.payload.pathname + action.payload.search;
            return preserveBrowseHistory(locationChanged(state, pathname), pathname);
        case BROKER_GET_MY_INVESTMENTS_SUCCESS:
            const hasRoboPortfolio = !!action.payload.roboAdvisor &&
                !!action.payload.roboAdvisor.portfolioOverviews &&
                !!action.payload.roboAdvisor.portfolioOverviews.length &&
                action.payload.roboAdvisor.activeCustomerTotal
            return state.set('hasRoboPortfolio', hasRoboPortfolio);
        case BROKER_CONVENIENCE_MIFID_TEST_RESULT_DISPLAYED:
            return state.set('resultDisplayed', true);
        case BROKER_CONVENIENCE_MIFID_TEST_CONSULT:
            let consultingState = INITIAL_STATE.merge({
                productId: action.payload.productId,
                fecha: action.payload.fecha,
                evaluationDescription: action.payload.evaluationDescription,
                consulting: true
            });

            consultingState = consultingState.set(
                'steps',
                updateStep(consultingState, FIRST_STEP, action)
            );
            consultingState = consultingState.set(
                'steps',
                updateStep(consultingState, SECOND_STEP, action)
            );
            consultingState = consultingState.set(
                'steps',
                updateStep(consultingState, THIRD_STEP, action)
            );

            return consultingState.deleteIn(['steps', FOURTH_STEP]);
        case BROKER_CONVENIENCE_MIFID_TEST_START:
            return applyMifid2Layer(start(state, action.payload), state.get('mifidv2'));
        case BROKER_CONVENIENCE_MIFID_TEST_SET_OPERATION_CODE_US_PERSON:
            return state.merge({
                mifidVersion: BROKER_MIFID_VERSION_2,
                mifidv2: brokerConvenienceMiFIDv2Reducer(state.get('mifidv2'), action),
                fetched: true,
                fetching: false,
            });
        case BROKER_CONVENIENCE_MIFID_TEST_GET_INVESTMENT_EXPERIENCE_SUCCESS:
            return state.merge({
                investmentExperience: action.payload.dataInvestmentExperience,
            });
        case BROKER_CONVENIENCE_MIFID_TEST_HANDLE_CLOSE_MODAL_INVESTMENT_EXPERIENCE:
            return state.merge({
                showInvestmentExperienceModal: !state.get('showInvestmentExperienceModal'),
            });
        case BROKER_CONVENIENCE_MIFID_TEST_FETCH_GET_TEST_SUCCESS:
            return state.merge({
                mifidVersion: BROKER_MIFID_VERSION_2,
                mifidv2: brokerConvenienceMiFIDv2Reducer(state.get('mifidv2'), action),
                fetched: true,
                fetching: false,
                showFirsTimePopUp: showPopup(action.payload.response),
                test: buildTest(action.payload.response),
            });
        case BROKER_CONVENIENCE_MIFID_TEST_FETCH_GET_TEST_FETCHING:
            return state.merge({
                fetched: false,
                fetching: true
            });
        case BROKER_CONVENIENCE_MIFID_TEST_RETAKE_TEST:
            return state.set('retakeTest', true)
                        .setIn(['test', 'takeTestWithAllQuestions'], action.payload);
        case BROKER_CONVENIENCE_MIFID_TEST_HARD_RESET:
            return getInitialState(state);
        case BROKER_CONVENIENCE_MIFID_TEST_RESET:
        case BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_GO_TO_MAKE_TEST:
            return applyMifid2Layer(reset(state), state.get('mifidv2'));
        case BROKER_CONVENIENCE_MIFID_TEST_FINISH_LOADING:
            return state.set('loading', true);
        case BROKER_CONVENIENCE_MIFID_TEST_FINISH_ERROR:
            return state.set('loading', false); // @hardcoded
        case BROKER_CONVENIENCE_MIFID_TEST_FINISH:
            return applyMifid2Layer(
                finish(state, action.payload.response),
                brokerConvenienceMiFIDv2Reducer(state.get('mifidv2'), action)
            );
        case BROKER_CONVENIENCE_MIFID_TEST_CONTINUE_WITH_DISAPPROVED_TEST:
            return state.merge({
                continueWithDisapproved: true,
            }).mergeIn(['test'], {
                    testStatus: 'testSuccess'
                })
        case BROKER_CONVENIENCE_MIFID_TEST_REVIEW_DISAPPROVED_TEST:
            return updateVisibleStep(state, action.payload.step)
                .set('continueWithDisapproved', false)
                .set('fetchedCurrentTest', false)
                .set('disaprovedCurrentTest', false)
        case BROKER_CONVENIENCE_MIFID_TEST_OMIT:
            return state.set('operateOmittingTest', true);
        case BROKER_CONVENIENCE_MIFID_TEST_SET_VISIBLE_STEP:
        case BROKER_CONVENIENCE_MIFID_TEST_STEP3_VERIFY_ANSWERS:
            const updatedVisibleStep = updateVisibleStep(state, action.payload.step);
            return updatedVisibleStep.set('steps', updateStep(updatedVisibleStep, THIRD_STEP, action));
        case BROKER_CONVENIENCE_MIFID_TEST_VALIDATE_STEP:
            return state.set('steps', updateStep(state, action.payload.step, action));
        case BROKER_CONVENIENCE_MIFID_TEST_STEP0_CHANGE_UPDATE_REASON:
            return state.set('steps', updateStep(state, MIFID_STEP_ZERO, action));
        case BROKER_CONVENIENCE_MIFID_TEST_STEP1_CHECK_INCOHERENCES:
        case BROKER_CONVENIENCE_MIFID_TEST_STEP1_CONTINUE_WITH_INCOHERENCES:
        case BROKER_CONVENIENCE_MIFID_TEST_STEP1_CHANGE_STUDY_LEVEL:
        case BROKER_CONVENIENCE_MIFID_TEST_STEP1_CHANGE_EXPERIENCE:
            return state.set('steps', updateStep(state, FIRST_STEP, action));
        case BROKER_CONVENIENCE_MIFID_TEST_STEP2_CHECK_INCOHERENCES:
        case BROKER_CONVENIENCE_MIFID_TEST_STEP2_CONTINUE_WITH_INCOHERENCES:
        case BROKER_CONVENIENCE_MIFID_TEST_STEP2_CHANGE_FINANCIAL_CULTURE:
            return state.set('steps', updateStep(state, SECOND_STEP, action));
        case BROKER_CONVENIENCE_MIFID_TEST_STEP3_CHECK_INCOHERENCES:
        case BROKER_CONVENIENCE_MIFID_TEST_STEP3_CONTINUE_WITH_INCOHERENCES:
        case BROKER_CONVENIENCE_MIFID_TEST_STEP3_CLOSE_INVALID_ANSWERS_MODAL:
        case BROKER_CONVENIENCE_MIFID_TEST_STEP3_CHANGE_EXPERIENCE_AS_INVESTOR:
            return state.set('steps', updateStep(state, THIRD_STEP, action));
        case BROKER_CONVENIENCE_MIFID_TEST_FETCH_CURRENT_TEST_RESULT_FETCHING:
            return state.set('loadingCurrentTest', true)
                        .set('errorCurrentTest', false)
                        .set('continueWithDisapproved', false)
                        .set('steps', updateStep(state, THIRD_STEP, action));
        case BROKER_CONVENIENCE_MIFID_TEST_FETCH_CURRENT_TEST_RESULT_ERROR:
            return state.set('loadingCurrentTest', false)
                        .set('errorCurrentTest', true)
        case BROKER_CONVENIENCE_MIFID_TEST_FETCH_CURRENT_TEST_RESULT_SUCCESS_APPROVED:
            return state.set('loadingCurrentTest', false)
                        .set('disaprovedCurrentTest', false)
                        .set('fetchedCurrentTest', true)
                        .set('errorCurrentTest', false)
                        .set('steps', updateStep(state, THIRD_STEP, action))
                        .setIn(
                            ["test", "testStatus"],
                            "testSuccess"
                        );
        case BROKER_CONVENIENCE_MIFID_TEST_FETCH_CURRENT_TEST_RESULT_SUCCESS_DISAPPROVED:
            return state.set('loadingCurrentTest', false)
                        .set('fetchedCurrentTest', true)
                        .set('errorCurrentTest', false)
                        .set('disaprovedCurrentTest', true)
                        .setIn(
                            ["test", "testStatus"],
                            "testFail"
                        );
        case BROKER_CONVENIENCE_MIFID_TEST_RESET_TEST_SCORE_STATUS:
            return state.set('continueWithDisapproved', false)
                        .set('fetchedCurrentTest', false)
                        .set('disaprovedCurrentTest', false)
        case BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_GO_TO_MY_WALLET:
        case BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_CONTINUE_OPERATION:
        case BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_CONTINUE_OPERATION_VALIDATE:
        case BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_CHANGE_ACCEPT_EVALUATION:
        case BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_OPERATE_OMITTING_TEST:
        case BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_NOT_CONVENIENT_ACCEPT:
            return state.merge(brokerConvenienceMiFIDTestStepSuccessReducer(state, action));
        case BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_CHANGE_TRANSCRIPTION:
        case BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_CANCEL:
        case BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_CONTINUE:
        case BROKER_CONVENIENCE_MIFID_TEST_STEP_OMIT_TEST_CONTINUE_SUCCESS:
            return state.merge(brokerConvenienceMiFIDTestStepOmitTestReducer(state, action));
        case BROKER_CONVENIENCE_MIFID_TEST_STEPS_INITIAL_STEPS:
            const initialSteps = isRenderStep0()
                ? [
                    brokerConvenienceMiFIDTestStep0Reducer(undefined, BROKER_CONVENIENCE_MIFID_TEST_STEPS_INITIAL_STEPS),
                    brokerConvenienceMiFIDTestStep1Reducer(undefined, BROKER_CONVENIENCE_MIFID_TEST_STEPS_INITIAL_STEPS),
                    brokerConvenienceMiFIDTestStep2Reducer(undefined, BROKER_CONVENIENCE_MIFID_TEST_STEPS_INITIAL_STEPS),
                    brokerConvenienceMiFIDTestStep3Reducer(undefined, BROKER_CONVENIENCE_MIFID_TEST_STEPS_INITIAL_STEPS),
                    brokerConvenienceMiFIDTestStep4Reducer(undefined, BROKER_CONVENIENCE_MIFID_TEST_STEPS_INITIAL_STEPS)
                ]
                : [
                    brokerConvenienceMiFIDTestStep1Reducer(undefined, BROKER_CONVENIENCE_MIFID_TEST_STEPS_INITIAL_STEPS),
                    brokerConvenienceMiFIDTestStep2Reducer(undefined, BROKER_CONVENIENCE_MIFID_TEST_STEPS_INITIAL_STEPS),
                    brokerConvenienceMiFIDTestStep3Reducer(undefined, BROKER_CONVENIENCE_MIFID_TEST_STEPS_INITIAL_STEPS),
                    brokerConvenienceMiFIDTestStep4Reducer(undefined, BROKER_CONVENIENCE_MIFID_TEST_STEPS_INITIAL_STEPS)
                ];
            return state.merge({
                "steps": initialSteps,
            })
        case BROKER_CONVENIENCE_MIFID_TEST_UPDATE_CATEGORY_AND_SUBCATEGORY:
            return state.mergeIn(['test', 'testState'], action.payload);
        case BROKER_CONVENIENCE_MIFID_TEST_UPDATE_ANSWER:
            return state.mergeIn(
                ["test", "schema"],
                updateAnswer(
                    state.get("test"),
                    action.payload,
                )
            );
        case BROKER_CONVENIENCE_MIFID_TEST_GO_TO_CONFIRMATION_STEP:
            return state.setIn(
                ["test", "testStatus"],
                "testSuccess"
            );
        case BROKER_CONVENIENCE_MIFID_TEST_GO_TO_FINISH_STEP:
            return state.set('finished', true);
        case BROKER_CONVENIENCE_MIFID_TEST_GO_TO_STEP:
            return state.set('continueWithDisapproved', false)
                .mergeIn(["test", "testState"], action.payload).setIn(
                    ["test", "testStatus"],
                    "inProgress"
            );
        case BROKER_CONVENIENCE_MIFID_TEST_DISABLED_BUTTON:
            return state.merge({
                disabledButton: false,
            })
        case BROKER_CONVENIENCE_MIFID_TEST_ENABLE_BUTTON:
            return state.merge({
                disabledButton: true,
            })
        case BROKER_CONVENIENCE_MIFID_TEST_SHOW_MODAL:
            return state.merge({
                showCoherenceModal: action.payload,
            })
        case BROKER_CONVENIENCE_MIFID_TEST_IS_ACCORDION_ANSWER:
            return state.merge({
                isAccordionAnswer: true
            })
        case BROKER_CONVENIENCE_MIFID_TEST_UPDATE_LIST_ANSWER_WITH_COHERENCE:
            return state.merge({
                listAnswerWithCoherence: action.payload
            })
        case BROKER_CONVENIENCE_MIFID_TEST_REVIEWING_TEST:
            return state.set("isReviewingTest", true);
        case BROKER_CONVENIENCE_MIFID_TEST_SHOW_PROFESSIONAL_EXPERIENCE_MODAL:
            return state.merge({
                showProfessionalExperienceModal: action.payload,
            });
        case BROKER_CONVENIENCE_MIFID_TEST_SHOW_PROFESSIONAL_EXPERIENCE_MODAL_WARNING:
            return state.merge({
                 showProfessionalExperienceModalWarning: action.payload,
            })
        case BROKER_CONVENIENCE_MIFID_TEST_SHOW_DIFFERENCE_MODAL:
            return state.set('showDifferenceModal', true);
        case BROKER_CONVENIENCE_MIFID_TEST_HIDE_DIFFERENCE_MODAL:
            return state.set('showDifferenceModal', false);
        case BROKER_CONVENIENCE_MIFID_TEST_HIDE_FIRST_TIME_POP_UP:
            return state.set('showFirsTimePopUp', false);
        case BROKER_CONVENIENCE_MIFID_TEST_ADD_PRIVATE_EQUITY_DISCLAIMERS:
            return state.merge({
                mifidv2: brokerConvenienceMiFIDv2Reducer(state.get('mifidv2'), action),
            });
        case BROKER_CONVENIENCE_MIFID_TEST_SET_CRYPTO_TEST_STATE:
            return state.setIn(
                ["test", "cryptoTestState"],
                action.payload
            );
        case BROKER_CONVENIENCE_MIFID_TEST_SET_CRYPTO_TEST_INDEX:
            return state.setIn(
                ["test", "cryptoTestIndex"],
                action.payload
            );
        case BROKER_CONVENIENCE_MIFID_TEST_SET_CRYPTO_TEST_LENGTH:
            return state.setIn(
                ["test", "cryptoTestLength"],
                action.payload
            );
        case BROKER_CONVENIENCE_MIFID_TEST_VERIFY_DOCUMENT_SIGNED_LOADING:
            return state.setIn(
                ["test", "verifyDocumentationLoading"],
                true
            )
        case BROKER_CONVENIENCE_MIFID_TEST_VERIFY_DOCUMENT_SIGNED_SUCCESS:
            return state.mergeIn(["test"], {
                documentationHasSigned: action.payload.exists,
                verifyDocumentationLoading: false
            });
        case BROKER_CONVENIENCE_MIFID_TEST_VERIFY_DOCUMENT_SIGNED_ERROR:
            return state.setIn(
                ["test", "verifyDocumentationLoading"],
                false
            )
        case BROKER_CONVENIENCE_MIFID_TEST_SET_EDITION_MODE:
            return state.setIn(["test", "isEditing"], action.payload);
        case BROKER_CONVENIENCE_MIFID_TEST_CLOSE_CRYPTO_RESULT_MODAL:
            return state.setIn(["test", "cryptoModalResult"], false);
        case BROKER_CONVENIENCE_MIFID_TEST_GET_CRYPTO_DOCUMENTATION_LOADING:
            return state.setIn(["test", "cryptoDocumentation" ,"cryptoDocumentationLoading"], true);
        case BROKER_CONVENIENCE_MIFID_TEST_GET_CRYPTO_DOCUMENTATION_SUCCESS:
            return state.mergeIn(["test", "cryptoDocumentation"], {
                base64String: action.payload.base64String,
                base64url: action.payload.base64url,
                cryptoDocumentationLoading: false
            });
        case BROKER_CONVENIENCE_MIFID_TEST_GET_CRYPTO_DOCUMENTATION_ERROR:
            return state.setIn(["test", "cryptoDocumentation" ,"cryptoDocumentationLoading"], false);
        case BROKER_CONVENIENCE_MIFID_TEST_REQUEST_CRYPTO_DOCUMENTATION_LOADING:
            return state.setIn(["test", "cryptoDocumentation", "cryptoOperationProcessIdLoading"], true);
        case BROKER_CONVENIENCE_MIFID_TEST_REQUEST_CRYPTO_DOCUMENTATION_SUCCESS:
            return state.updateIn(["test", "cryptoDocumentation"], (cryptoDoc) => {
                return cryptoDoc.merge({
                    cryptoOperationProcessIdLoading: false,
                    cryptoOperationProcessId: action.payload.operationProcessId,
                    cryptoDocumentationLoading: false,
                    base64String: null,
                    base64url: null,
                });
            });
        case BROKER_CONVENIENCE_MIFID_TEST_REQUEST_CRYPTO_DOCUMENTATION_ERROR:
            return state.setIn(["test", "cryptoDocumentation", "cryptoOperationProcessIdLoading"], false);
        case BROKER_CONVENIENCE_MIFID_TEST_SIGN_DOCUMENT_LOADING:
            return state.setIn(
                ["test", "cryptoDocumentation", "cryptoDocumentationSignLoading"],
                true
            );
        case BROKER_CONVENIENCE_MIFID_TEST_SIGN_DOCUMENT_SUCCESS:
            return state.mergeIn(["test", "cryptoDocumentation"], {
                cryptoDocumentationSignLoading: false,
                documentationHasSigned: true,
            });
        case BROKER_CONVENIENCE_MIFID_TEST_SIGN_DOCUMENT_ERROR:
            return state.setIn(
                ["test", "cryptoDocumentation", "cryptoDocumentationSignLoading"],
                false
            );
        default:
            return state;
    }
}

module.exports = brokerConvenienceMiFIDTestReducer;
